// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"2756b9f6","337":"60d74ed2","453":"18613a04","667":"0a7a1a3b"}[chunkId] + ".chunk.js";
};